import styled, { css } from 'styled-components';

interface JobListProps {
  length?: number;
}

export const Contents = styled.div`
  display: flex;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }
`;

export const Poster = styled.div`
  flex: 0 0 234px;
  height: 136px;
  background-color: ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${({ theme }) => theme.media.mobile} {
    flex: 0 0 auto;
  }
`;

export const CompanyCardWrapper = styled.div`
  margin-bottom: 16px;
`;

export const JobList = styled.div<JobListProps>`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-left: 16px;

  ${({ theme }) => theme.media.mobile} {
    margin-left: 0;
    margin-top: 16px;

    ${({ length }) =>
      length <= 1 &&
      css`
        grid-template-columns: 1fr;
      `}
  }
`;
